import { invokeApig } from '../../libs/awsLib';

const POP_CUSTOM_COL_SETTINGS_KEY = 'custom-pop-custom-col-settings';

export function getPopCustomColumnSettings(username) {
  const key = POP_CUSTOM_COL_SETTINGS_KEY + '-' + username;

  try {
    if (window.localStorage[key] && window.localStorage[key] !== 'null') {
      const value = JSON.parse(window.localStorage[key]);

      if (Array.isArray(value)) {
        return value;
      }
    }

    return [];
  } catch (e) {
    return [];
  }
}

export const savePopCustomColumnSettings = async function (
  username,
  columnSettings
) {
  const key = POP_CUSTOM_COL_SETTINGS_KEY + '-' + username;
  window.localStorage.setItem(key, JSON.stringify(columnSettings));

  try {
    await invokeApig({
      path: '/custom-population-rr/column-settings',
      method: 'POST',
      body: { column_settings: columnSettings },
    });
  } catch (ex) {
    console.error(ex);
  }
};

export const resetPopCustomColumnSettings = async function (username) {
  const key = POP_CUSTOM_COL_SETTINGS_KEY + '-' + username;
  window.localStorage.removeItem(key);

  try {
    await invokeApig({
      path: '/custom-population-rr/column-settings',
      method: 'DELETE',
      body: { username: username },
    });
  } catch (error) {
    console.error(error);
  }
};

export const COLUMNS_STATE_KEYS = {
  sorting: 'sorting',
  filters: 'filters',
  smartFiltersIds: 'smartFiltersIds',
  selectedSmartFiltersButtonsIds: 'selectedSmartFiltersButtonsIds',
  smartFilters: 'smartFilters',
  selectedSmartFiltersButtons: 'selectedSmartFiltersButtons',
};

export const getPopulationKey = (populationName, username) =>
  `${populationName}-${username}-columns-state`;

export const saveColumnsStateToSession = (populationKey, state, key) => {
  const stored = sessionStorage.getItem(populationKey);

  if (!stored) {
    sessionStorage.setItem(populationKey, JSON.stringify({ [key]: state }));
    return;
  }

  try {
    const parsed = JSON.parse(stored);
    sessionStorage.setItem(
      populationKey,
      JSON.stringify({
        ...parsed,
        [key]: state,
      })
    );
  } catch (e) {
    console.error(e);
  }
};

export const getColumnsStateFromSession = (populationKey, key) => {
  const stored = sessionStorage.getItem(populationKey);

  if (!stored) return [];

  try {
    const parsed = JSON.parse(stored);

    return parsed?.[key] ?? [];
  } catch {
    return [];
  }
};

export const clearColumnsStateFromSession = (populationKey) => {
  sessionStorage.removeItem(populationKey);
};

export const clearAllCustomPopPersistStates = () => {
  const keysToRemove = Array.from(
    { length: sessionStorage.length },
    (_, index) => sessionStorage.key(index)
  ).filter((key) => key?.includes('-columns-state'));

  keysToRemove.forEach((key) => sessionStorage.removeItem(key));
};
